import Q5FederalOrState from './Q5FederalOrState';
export default Q5FederalOrState;